import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7001Model } from '../kymw7001.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { CodeListInfo } from '../vo/code_list_info.model';

// レスポンス構造
type GetFeatureListResponse = {
  FeatureCode: string;
  FeatureName: string;
}[];

/**
 * 特集情報一覧取得サービス
 * @export GetFeatureListService
 * @class GetFeatureListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetFeatureListService extends PlessJsonResponderSub<GetFeatureListResponse> {
  model: KYMW7001Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFeatureListService
   */
  private getBody(): PlessRequest {
    const searchObj = {
      GetFeatureList: {
        condition: {
          OrderCode: this.model.orderCode,
          MediumType: this.model.mediumType
        },
      }
    }

    return new PlessRequest({ search: searchObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetFeatureListService
   */
  execute(model: KYMW7001Model, f?: () => void): void {
    this.model = model;
    if (f) this.calbak = f;
    this.send('KYMW70getFeatureList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetFeatureListService
   */
  success(data: GetFeatureListResponse) {
    const featureList = [];
    data.forEach(item => {
      const addList = new CodeListInfo(item.FeatureCode,item.FeatureName);
      featureList.push(addList);
    })
    this.model.FeatureList = (featureList)
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
